import React, {Component} from 'react';
import MenuCalendrier from "../components/MenuCalendrier";
import {Button, Container, Divider, Grid, Icon, Input, Label, Menu, Segment, Sticky} from "semantic-ui-react";
import {connect} from "react-redux";
import {changeFormatSpot, clear} from "../actions/panier";

class SelecteurProduitsLayout extends Component {

  totalTarif() {
    let total = 0;
    this.props.panier.forEach(v => total += v.tarif(this.props.formatSpot));
    return total;
  }

  totalAudience() {
    let total = 0;
    this.props.panier.forEach(v => total += v.audience());
    return total;
  }

  render() {

    return (
        <Grid centered>
          <Grid.Column width={3}>
            <Sticky offset={50}>
              <Menu vertical fluid size='large'>
                <Menu.Item header active color='teal'>
                  <Icon name='trash' size='large' color='red' link onClick={this.props.clearPanier}/>
                  <span>
                    <Icon name='cart' size='large'/>{' '}Panier{' '}<Label circular color='teal'>{this.props.panier.length}</Label>
                  </span>
                </Menu.Item>
                {this.props.panier.map(v =>
                    <Menu.Item>
                      {v.produit.libelle} - {v.semaine.code} {v.produit.isPressionsMultiples() ? ' - P' + v.pression : ''}
                    </Menu.Item>
                )}
                <Menu.Item header active color='orange'>
                  <div>
                    Audience : {this.totalAudience().formatFr()}
                  </div>
                  <div>
                    Tarif : {this.totalTarif().formatEuros()}
                  </div>
                </Menu.Item>
              </Menu>

              <Menu vertical fluid size='large'>
                <Menu.Item header active color='teal'>
                  <span>
                    <Icon name='time' size='large'/>{' '}Format du spot écran
                  </span>
                </Menu.Item>
                <Menu.Item>
                  <Input fluid value={this.props.formatSpot}>
                    <Button size='mini' icon='minus' onClick={() => this.props.changeFormatSpot(this.props.formatSpot - 1)}/>
                    <input/>
                    <Button size='mini' disabled>secondes</Button>
                    <Button size='mini' icon='plus' onClick={() => this.props.changeFormatSpot(this.props.formatSpot + 1)}/>
                  </Input>
                </Menu.Item>
              </Menu>
            </Sticky>
          </Grid.Column>
          <Grid.Column width={13} ref={this.handleStickyRef}>
            <Segment textAlign={'center'}>
              <MenuCalendrier/>
              <Divider/>
              <Container fluid textAlign='left'>
                {this.props.children}
              </Container>
            </Segment>
          </Grid.Column>
        </Grid>
    );
  }
}


const mapStateToProps = (state) => ({
  formatSpot: state.panier.formatSpot,
  panier: state.panier.panier
});

const mapDispatchToProps = (dispatch) => ({
  changeFormatSpot: (formatSpot) => dispatch(changeFormatSpot(formatSpot)),
  clearPanier: () => dispatch(clear())
});

export default connect(mapStateToProps, mapDispatchToProps)(SelecteurProduitsLayout);
